import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RecoilRoot } from 'recoil'

import { App } from './App'
import { installApiInterceptors } from './lib/apiClient'
import { applyDomSafePatch } from './lib/domSafePatch'

// ブラウザ翻訳・拡張機能によるDOM書き換えで removeChild/insertBefore が
// クラッシュするのを防ぐ。Reactのrenderより前に適用する必要がある。
applyDomSafePatch()

// /api へのリクエストに Cognito の ID トークンを付ける。
installApiInterceptors()

const container = document.getElementById('root')
if (!container) {
  throw new Error('No such #root element')
}

const root = createRoot(container)
root.render(
  <StrictMode>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  </StrictMode>,
)
